import React, { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import Input from '../../../atoms/Input/Input';
import { Field } from 'redux-form';
import FormField from '../../../atoms/Form/Field/FormField';
import FieldError from '../../Error/FieldError';
import { getConfidenceFieldStyle } from '../../../../helpers/form';

const EmailFieldRender = ({
  input,
  label,
  placeholder,
  id,
  readonly,
  confidence,
  isFocusOnInit,
  meta: { error, touched },
}) => {
  const style = useMemo(() => {
    if (touched) return null;
    return getConfidenceFieldStyle(confidence);
  }, [confidence, touched]);

  return (
    <>
      <Input
        type="text"
        {...input}
        isFocusOnInit={isFocusOnInit}
        error={!!(touched && error)}
        label={label}
        id={id}
        block
        readonly={readonly}
        placeholder={placeholder}
        style={style}
      />
      {touched && error && <FieldError error={error} />}
    </>
  );
};

EmailFieldRender.propTypes = {
  isFocusOnInit: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.any,
    touched: PropTypes.bool,
  }),
  id: PropTypes.string,
  readonly: PropTypes.bool,
  confidence: PropTypes.number,
};

const EmailField = ({
  name,
  label,
  required,
  information,
  fieldHoC: FieldHOC = Field,
  answersChoices,
  confidence,
  ...props
}) => {
  const id = useMemo(() => uuid(), [name]);
  return (
    <FormField
      label={label}
      name={name}
      htmlFor={id}
      information={information}
      required={required}
      answersChoices={answersChoices}
      verticalAlign={true}
      confidence={confidence}
    >
      <FieldHOC
        name={name}
        component={EmailFieldRender}
        id={id}
        confidence={confidence}
        {...props}
      />
    </FormField>
  );
};

EmailField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  information: PropTypes.string,
  fieldHoC: PropTypes.func,
  answersChoices: PropTypes.array,
  confidence: PropTypes.number,
};

export default EmailField;
